import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { postAllData } from '../../service/ProductService';
import { SCRUTINY_VERIFICATION_UPDATE } from '../../config/ApiConstant';
import { Checkbox } from 'primereact/checkbox';
import { verificationChoiceData } from '../../appconfig/Settings';

const ScrutinyUploadReplyModal = (props: any) => {
    const toast = useRef<any>(null);

    const { dismissClick, openmodel, id, srNo, replyUpload, selectedData } = props;

    const [holdBtnSpinner, setHoldBtnSpinner] = useState<boolean>(false);
    const [selected, setSelected] = useState([]);

    const [errors, setErrors] = useState<any>({});
    const [uploadData, setUploadData] = useState<any>({});

    // useEffect
    useEffect(() => {
        if (selectedData.length > 0) {
            let _selectedCategories: any = [];

            selectedData.map((item: any) => {
                let selectedData = verificationChoiceData.find((category: any) => category.key == item);
                _selectedCategories.push(selectedData);
            });

            setSelected(_selectedCategories);
        }
    }, [selectedData]);

    const addUploadReply = async () => {
        try {
            setHoldBtnSpinner(true);

            // Request Data
            let formData = new FormData();

            formData.append('id', id);
            formData.append('SrNo', srNo);

            let result: any;
            if (selected.length > 0) {
                result = selected.map((item: any) => item?.name);
            }

            if (replyUpload == 'Reply') {
                formData.append('reply', result.toString());
            }

            if (!window.cn(uploadData?.photo)) {
                if (replyUpload == 'Reply') {
                    formData.append('reply_file', uploadData?.photo);
                } else {
                    formData.append('file_url', uploadData?.photo);
                }
            }

            // Api Call
            const response = await postAllData(SCRUTINY_VERIFICATION_UPDATE, formData);

            if (response) {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });

                setHoldBtnSpinner(false);
                clearAll();
            }
        } catch (error: any) {
            if (error.response) {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });

                setHoldBtnSpinner(false);

                clearAll();
            }
        }
    };

    //on input change event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'photo') {
            val = e.target.files[0] || '';
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }

        setUploadData({ ...uploadData, [name]: val });
    };

    //checkboxchange
    const onVerificationChange = (e: any) => {
        let _selectedCategories: any = [...selected];

        if (e.checked) _selectedCategories.push(e.value);
        else _selectedCategories = _selectedCategories.filter((category: any) => category.key !== e.value.key);

        setSelected(_selectedCategories);
    };

    // Close And Clear
    const clearAll = () => {
        dismissClick();
        setSelected([]);
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={openmodel}
                className="p-fluid"
                style={{ width: '600px' }}
                header={replyUpload == 'Reply' ? 'Reply' : 'Upload'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => clearAll()} />
                        <Button label="Submit" icon="pi pi-check" onClick={() => addUploadReply()} loading={holdBtnSpinner} />
                    </>
                }
                onHide={() => clearAll()}
            >
                {replyUpload == 'Reply' ? (
                    <>
                       
                        <div className="card flex justify-content-center">
                            <div className="flex flex-wrap  gap-3">
                                {verificationChoiceData.map((category: any) => {
                                    return (
                                        <div key={category.key} className="flex align-items-center">
                                            <Checkbox inputId={category.key} name="category" value={category} onChange={onVerificationChange} checked={selected.some((item: any) => item.key === category.key)} />
                                            <label htmlFor={category.key} className="ml-2">
                                                {category.name}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                ) : (
                    ''
                )}
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <label htmlFor="photo">Upload File *</label>
                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1.2rem', marginRight: '0.5rem' }}></i>
                            <span>Upload Document</span>
                            <input type="file" id="fileInput" accept="image/png, image/jpeg , image/jpg  , application/pdf" onChange={(e) => onInputChange(e, 'photo')} className="file-input" />
                        </div>

                        {uploadData?.photo && (
                            <div className="file-preview">
                                <div className="file-info">
                                    <a href={URL.createObjectURL(uploadData?.photo)} target="_blank" rel="noopener noreferrer" className="file-name">
                                        {uploadData?.photo.name}
                                    </a>
                                    <span className="file-details">
                                        {uploadData?.photo.type} &nbsp;♦&nbsp; {(uploadData?.photo.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                            </div>
                        )}

                        <small className="p-invalid-txt">{errors['photo']}</small>
                    </div>
                </div>
            </Dialog>
        </>
    );
};
export default ScrutinyUploadReplyModal;
